
















































import { defineComponent, computed, onMounted, watch, toRefs, PropType } from '@vue/composition-api';
import _ from 'lodash-es';
import { PlatformType } from '@ad/tt_ads_common_enums';
import { trackEvent } from './../../../utils/index';

import TtamAppEventsAppSelect from './app-events/app-select/index.vue';
import TtamAppEventsAppIosHint from './app-events/app-ios-hint.vue';
import TtamAppEventsAppAndroidHint from './app-events/app-android-hint.vue';
import { StateEnum, useStore } from '@tt4b/ttam-hooks';
import { AcoFormData, AdgroupFormData, CampaignFormData, CreativeConfig, FullNormalFormData } from '@tt4b/ttam-enums';
import { useAppEvents } from './hooks/useAppEvents';
import { AppDataItem } from './types';
import TtamTrackingDataEmpty from './tracking-data-empty.vue';

const name = 'ttam-ad-tracking-app-events-compose';

export default defineComponent({
  name,
  components: {
    TtamAppEventsAppSelect,
    TtamAppEventsAppIosHint,
    TtamAppEventsAppAndroidHint,
    TtamTrackingDataEmpty,
  },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    creativeData: {
      type: Object as PropType<FullNormalFormData & AcoFormData>,
      default: () => ({}),
    },
    creativeConfig: {
      type: Object as PropType<CreativeConfig>,
      default: () => ({}),
    },
    // ad group层级字段对应的一个计算属性: 是否是app重定向
    isRetargetingApp: {
      type: Boolean,
      default: false,
    },
    isInnerOperation: {
      type: Boolean,
      default: false,
    },
    isNewTiktokEventTrack: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { campaignData, adgroupData, creativeData, creativeConfig, isRetargetingApp } = toRefs(props);
    const { state } = useStore();

    const aadvid = computed(() => state[StateEnum.baseInfo].value?.aadvid);

    const addUrl = computed(() => `/i18n/events_manager/app?aadvid=${aadvid.value}&refer=ads_creation_drop_list`);

    const _trackingAppId = computed({
      get: () => creativeData.value?.trackingAppId || '',
      set: (val: string) => {
        emit('change', val);
      },
    });

    const { isEmpty, loading, dataSource, loadAppList, isAppSelectDisabled } = useAppEvents({
      campaignData,
      adgroupData,
      creativeConfig,
      isRetargetingApp,
    });

    const curAppItem = computed(() => dataSource.value?.find(i => i.Id === _trackingAppId.value));

    const isShowIosAppTips = computed(() => curAppItem.value && curAppItem.value?.Platform === PlatformType.IOS);

    const isShowAndroidAppTips = computed(
      () => curAppItem.value && curAppItem.value?.Platform === PlatformType.ANDROID,
    );

    onMounted(() => {
      loadAppList();
    });

    watch(
      () => curAppItem.value,
      val => {
        if (!_.isEmpty(val) && val?.Id) {
          const { Id: trackingAppInfoId } = creativeData.value?.trackingAppInfo || {};
          // 确保trackingAppInfo初始化的值
          if (val?.Id !== trackingAppInfoId) {
            emit('change-app-info', val);
          }
        }
      },
    );

    const onInput = (id: string) => {
      emit('input', id);
    };

    const onChange = (item: AppDataItem) => {
      trackEvent('select_ad_app_tracking');
      emit('change', item);
    };

    const onRefresh = () => {
      loadAppList();
      trackEvent('refresh_ad_app_tracking');
    };

    const onCreate = () => {
      trackEvent('create_ad_app_tracking');
    };

    const onOpen = () => {
      trackEvent('click_ad_app_tracking', {
        result: Boolean(dataSource.value?.length),
      });
    };

    const onFocus = () => {
      trackEvent('click_ad_app_tracking', { result: isEmpty.value });
    };

    const onClear = () => {
      emit('change', {});
      trackEvent('delete_ad_app_tracking');
    };

    return {
      name,
      addUrl,
      isEmpty,
      loading,
      dataSource,
      _trackingAppId,
      isAppSelectDisabled,
      isShowIosAppTips,
      isShowAndroidAppTips,

      onRefresh,
      onChange,
      onInput,
      onCreate,
      onFocus,
      onClear,
      onOpen,
    };
  },
});
